import { axios } from 'utils'

export const settingService = {
  get,
}

function get(param) {
  return axios.post(`/setting`, param)
}
